/**
 * Notes by bob@knottenwol.nl June 2026
 * Custom JS overrides for the Expanse theme.
 * Most of this is generated by asking Claude.
 */

/*
======================
== Variant buttons ==
======================
*/

/**
 * On mouseenter of a variant button, preview the corresponding product image
 * without triggering price/URL/inventory updates.
 * On mouseleave of the entire picker, restore the selected variant's image.
 */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('block-variant-picker').forEach(picker => {
    const variantData = JSON.parse(picker.querySelector('[type="application/json"]').textContent);
    const productImages = document.querySelector(`product-images[data-product-id="${picker.dataset.productId}"]`);
    if (!productImages) return;

    function goToMedia(mediaId) {
      const slide = productImages.querySelector(`.product-main-slide[data-media-id="${mediaId}"]`);
      if (!slide) return;
      const index = parseInt(slide.dataset.index, 10);
      if (isNaN(index)) return;
      if (productImages.flickity) {
        productImages.flickity.goToSlide(index);
      } else if (productImages.settings?.mediaGalleryLayout === 'stacked') {
        productImages.scrollToStackedMedia(index);
      }
    }

    function findVariant(overrideInput) {
      // Build option map from currently checked inputs, then override with hovered input
      const options = {};
      picker.querySelectorAll('input[type="radio"]:checked').forEach(input => {
        if (input.dataset.index) options[input.dataset.index] = input.value;
      });
      if (overrideInput?.dataset.index) options[overrideInput.dataset.index] = overrideInput.value;

      // Try to find a full match first, then fall back to any variant with the hovered value
      return (
        variantData.find(v => Object.entries(options).every(([k, val]) => v[k] === val) && v.featured_media) ||
        (overrideInput && variantData.find(v => v[overrideInput.dataset.index] === overrideInput.value && v.featured_media))
      );
    }

    picker.querySelectorAll('.variant-button-wrap label').forEach(label => {
      label.addEventListener('mouseenter', () => {
        const input = label.querySelector('input[type="radio"]');
        if (!input || label.classList.contains('disabled')) return;
        const variant = findVariant(input);
        if (variant?.featured_media) goToMedia(variant.featured_media.id);
      });
    });

    // Restore selected variant image when leaving the entire picker
    picker.addEventListener('mouseleave', () => {
      const variant = findVariant(null);
      if (variant?.featured_media) goToMedia(variant.featured_media.id);
    });
  });
});
